import * as actions from "../../../actions/tagColor/create";

const initialTagColorState = {
  name: "",
  hexCode: "#000000",
  active: true,
  errors: {}
};

const initialState = {
  loading: false,
  ...initialTagColorState
};

const reducer = function(state = initialState, { type, payload }) {
  switch (type) {
    case actions.SET_VALUE: {
      return {
        ...state,
        ...payload
      };
    }
    case actions.CLEAR_VALUE: {
      return {
        ...state,
        ...initialTagColorState
      };
    }
    case actions.ADD_TAG_COLOR: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.ADD_TAG_COLOR_FAILED: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.ADD_TAG_COLOR_SUCCESS: {
      return {
        ...state,
        loading: false
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
